import Vue from "vue";
import ProgressView from "../../components/common/progress";

/**
 * しばらくお待ちくださいを表示する
 */
class Progress {
  /**
   * しばらくお待ちくださいの格納コンテナのIDを取得する
   */
  get id() {
    return "progress-container";
  }

  /**
   * しばらくお待ちくださいの格納コンテナの中の表示部品を取得する
   */
  get elementId() {
    return "progress-item";
  }

  /**
   * しばらくお待ちくださいの格納コンテナを取得する
   */
  get element() {
    return document.getElementById(this.id);
  }

  /**
   * 格納コンテナをクリアする
   */
  clear() {
    this.element.innerHTML = `<div id = "${this.elementId}"></div>`;
  }

  /**
   * しばらくお待ちくださいを表示する
   */
  show() {
    new Vue({
      render: (h) => h(ProgressView),
    }).$mount(`#${this.elementId}`);
  }

  /**
   * しばらくお待ちくださいを隠す
   */
  hide() {
    this.clear();
  }
}

export default new Progress();
